const mutations = {
  getFlow: (state, flow_id) => {
    state.flow_id = flow_id;
  },
  postFlow: (state, new_flow) => {
    state.flow.push(new_flow);
  },
};

export default mutations;
